export enum EnumTipoAnexo {
	Nenhum = 0,
	Risco = 1,
	AvaliarRisco = 2,
	TesteMedicaoRiscos = 3,
	TipoRisco = 4,
	Ocorrencia = 5,
	AvaliarControle = 6,
	Controle = 7,
	Obrigacao = 8,
	Acao = 9,
	EtapaAcao = 10,
	EtapaObrigacao = 11,
	Processo = 12,
	Avaliacao = 13,
	ListarObrigacoesRiscos = 14,
	ListarObrigacoesEmpresa = 15,
	ListarAcoesRiscos = 16,
	ListarAcoesEmpresa = 17,
	TesteMedicaoControle = 18,
	ListarOcorrencia = 19,
}
